<template>
    <div>
        <section class="content">
            <div class="col-md-12" v-if="getMember.formations">
                <div class="portlet light"
                     v-for="(formations,key) in getFormationsOrdered()"
                >
                  <div class="portlet-title" :style="{ 'min-height': hasPrevious2007(getOrderByDate(formations)) ? '48px':'32px' }">
                        <div class="caption pull-left">
                            <div class="subject">
                                <span class="caption-subject">Mes formations et diplômes "{{ getName(key)}}"</span>
                                <span class="caption-helper"></span>
                            </div>
                            <div class="subsubject" v-if="hasPrevious2007(getOrderByDate(formations))">
                                Pour des raisons techniques, les données antérieures à l'année 2007 ne peuvent être garanties ou comporter certaines erreurs.
                            </div>
                        </div>
                    </div>
                    <div class="portlet-body">
                        <table class="table table-responsive table-hover"
                               v-if="formations.length>0">
                            <thead>
                            <tr>
                                <th>Date de formation</th>
                                <th>Formation</th>
                                <th>Diplôme</th>
                                <th>Réussite</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="formation in getOrderByDate(formations)">
                                <td>{{formation.date}}</td>
                                <td>{{formation.formation}}</td>
                                <td>{{formation.diplome =="Aucun" ? '-' : formation.diplome}}</td>
                                <td>
                                    <span class="text-success text-uppercase" v-if="formation.reussite"><strong>OUI</strong></span>
                                    <span class="text-danger text-uppercase" v-if="!formation.reussite"><strong>NON</strong></span>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                        <div v-if="formations.length==0">Aucune formation/diplôme trouvée</div>
                    </div>
                </div>
            </div>

        </section>
    </div>
</template>

<script type="text/babel">
    import Auth from '@/auth'
    import moment from 'moment/moment'
    import {mapGetters, mapActions} from 'vuex'

    export default {
        data() {
            return {}
        },
        methods: {
            hasPrevious2007(table) {
                return _.find(table, function(item) {
                    return item.annee<2007
                })
            },
            currentYear: function () {
                return moment().year();
            },
            getName(key) {
                switch (key) {
                    case "aisf":
                        return "AISF";
                        break;
                    case "abft":
                        return "ABFT";
                        break;
                    case "abitre_cbt":
                        return "Arbitrage combat";
                        break;
                    case "adeps":
                        return "ADEPS";
                        break;
                    case "arbitre_tch":
                        return "Arbitrage technique";
                        break;
                    case "ETU":
                        return "ETU";
                        break;
                    case "WTF":
                        return "WT";
                        break;
                }
                return "";
            },
            // getFormationsOrdered: function () {
            //     let ordered = [];
            //     let these = this
            //     this.getOrder().forEach(function (item, index, array) {
            //         if (these.getMember.formations[item])
            //             ordered.push({item: these.getMember.formations[item]});
            //     })
            //     return ordered;
            // },
            getFormationsOrdered() {
                return {
                    "abft": this.getMember.formations.abft ? this.getMember.formations.abft : [],
                    "adeps": this.getMember.formations.adeps ? this.getMember.formations.adeps : [],
                    "abitre_cbt": this.getMember.formations.abitre_cbt ? this.getMember.formations.abitre_cbt : [],
                    "arbitre_tch": this.getMember.formations.arbitre_tch ? this.getMember.formations.arbitre_tch : [],
                    "aisf": this.getMember.formations.aisf ? this.getMember.formations.aisf : [],
                    "ETU": this.getMember.formations.ETU ? this.getMember.formations.ETU : [],
                    "WTF": this.getMember.formations.WTF ? this.getMember.formations.WTF : [],
                }
            },
            // getFormations() {
            //     return [
            //         this.getMember().formations.aisf,
            //         this.getMember().formations.adeps,
            //         this.getMember().formations.abitre_cbt,
            //         this.getMember().formations.arbitre_tch,
            //         this.getMember().formations.abft
            //     ]
            // },
            getOrderByDate(formations) {
                return _.sortBy(formations, 'dateSorted',).reverse()
            }
        },
        components: {},
        computed: {
            ...mapGetters({
                getMember: 'getMember'
            })
        },
    };
</script>



// WEBPACK FOOTER //
// src/components/Member/PalmaresPoomsae.vue